// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  cursor: pointer;
  font-size: 10px;
  color: #282c34;
  min-width: 15.75em;
  max-width: 15.75em;
  min-height: 22em;
  max-height: 22em;
  border-radius: 1em;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  background: whitesmoke;
  -webkit-box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.7);
          box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.7);
  -webkit-transform: rotate(0deg) scale(0.9);
          transform: rotate(0deg) scale(0.9);
  overflow: hidden;
  border: 0.5em solid whitesmoke;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-transition: top 1s, left 1s, margin 1s, -webkit-transform 1s;
  transition: top 1s, left 1s, margin 1s, -webkit-transform 1s;
  transition: top 1s, left 1s, transform 1s, margin 1s;
  transition: top 1s, left 1s, transform 1s, margin 1s, -webkit-transform 1s;
}
.card:not(.hidden):not(.locked):hover {
  z-index: 10;
  -webkit-transition: margin-top 0.5s, top 1s, left 1s, -webkit-transform 0.5s;
  transition: margin-top 0.5s, top 1s, left 1s, -webkit-transform 0.5s;
  transition: transform 0.5s, margin-top 0.5s, top 1s, left 1s;
  transition: transform 0.5s, margin-top 0.5s, top 1s, left 1s, -webkit-transform 0.5s;
  -webkit-transform: rotate(2deg) scale(1.2);
          transform: rotate(2deg) scale(1.2);
  -webkit-box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.5), 0px 3px 12px 0px rgba(0, 0, 0, 0.3);
          box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.5), 0px 3px 12px 0px rgba(0, 0, 0, 0.3);
}
.card > div > div > div {
  --tag-size: 12px;
  min-width: calc(var(--tag-size) * 2);
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 0.4em 0em 0;
  font-size: 1.1em;
  min-height: 1.2em;
  color: #525252;
  position: relative;
}
.card > div > div > div::after {
  content: "";
  -webkit-transform-origin: top;
          transform-origin: top;
  -webkit-transform: scale(1, 0.5);
          transform: scale(1, 0.5);
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  position: absolute;
  bottom: calc(var(--tag-size) * -2);
  left: 0;
  border: calc(var(--tag-size)) solid transparent;
  border-top-color: whitesmoke;
}
.card > div > div > div::before {
  display: none;
}
.card.selected {
  margin-top: -20px;
}
.card.locked {
  cursor: default;
  z-index: 2;
}
.card.hidden {
  background: #282c34;
  color: transparent;
  cursor: default;
  border: 0;
}
.card.hidden .card-blue {
  background: #382491;
}
.card.hidden .card-red {
  background: var(--red);
}
.card.hidden .card-green {
  background: var(--green);
}
.card.hidden h2 {
  color: transparent;
}
.card.hidden .card-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  -ms-flex-pack: distribute;
      justify-content: space-around;
  background-image: linear-gradient(149deg, rgba(255, 255, 255, 0.29) 1px, transparent 1px, rgba(255, 255, 255, 0.09) 50%, rgba(0, 0, 0, 0.12) 99%);
}
.card.hidden .card-content .card-icon .logo {
  height: 100%;
  position: absolute;
  top: 0;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.2;
}
.card.hidden .card-content .card-icon .texture {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.3;
}
.card.bonus {
  -webkit-transform: rotate(180deg) scale(0.9);
          transform: rotate(180deg) scale(0.9);
  -webkit-box-shadow: 0px -2px 4px 1px rgba(0, 0, 0, 0.5), 0px -3px 12px 0px rgba(0, 0, 0, 0.3);
          box-shadow: 0px -2px 4px 1px rgba(0, 0, 0, 0.5), 0px -3px 12px 0px rgba(0, 0, 0, 0.3);
}
.card.stacked {
  -webkit-transform: translate(-18px, 5px) scale(0.9);
          transform: translate(-18px, 5px) scale(0.9);
}
.card.bonus.stacked {
  -webkit-transform: rotate(180deg) translate(18px, -5px) scale(0.9);
          transform: rotate(180deg) translate(18px, -5px) scale(0.9);
}
.card label {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 2em;
  padding: 0;
}
.card label h2 {
  font-size: 1.2em;
  text-align: center;
  padding: 1em 0;
  text-transform: uppercase;
  color: white;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
  white-space: nowrap;
  color: #4c4f55;
}
.card .card-value {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.card .card-value .card-value-num {
  font-size: 1.25em;
  color: hsl(127, 32%, 17%);
}
.card .card-value .card-value-icons {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  text-align: left;
}
.card .card-value .card-value-icons.inverse path {
  stroke: currentColor;
  stroke-width: 0.2px;
  fill: transparent;
}
.card .card-bottom .card-value {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
      -ms-flex-direction: row-reverse;
          flex-direction: row-reverse;
}
.card .card-bottom .card-value .card-value-icons {
  text-align: right;
}
.card .card-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  height: 100%;
  min-height: 100%;
  width: 100%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  border-radius: 0.7em;
  overflow: hidden;
  background-color: rgb(231, 231, 231);
}
.card .card-content.card-attack {
  background: linear-gradient(135deg, rgb(110, 223, 125) 0%, rgb(110, 223, 125) 100%);
}
.card .card-content.card-defense {
  background: linear-gradient(135deg, rgb(182, 182, 219) 0%, rgb(182, 182, 219) 100%);
}
.card .card-content .card-icon img {
  width: 85%;
  opacity: 0.75;
  margin: -3.5em 0;
}
.card .card-content .card-icon img.texture {
  position: absolute;
  top: 0;
  left: 0;
}
.card .card-content .card-logo img {
  width: 100%;
  height: 100%;
  opacity: 0.3;
  mix-blend-mode: lighten;
}
.card .card-up,
.card .card-bottom {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 0.25em;
  padding: 0 0.25em;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.card .card-up > div,
.card .card-bottom > div {
  background: whitesmoke;
  /*
  &:nth-child(3) {
    background: linear-gradient(
      135deg,
      rgba(199, 150, 70, 1) 0%,
      rgba(245, 202, 138, 1) 84%,
      rgba(255, 255, 255, 0) 84%
    );
  }
  */
}
.card .card-up > div .card-value,
.card .card-bottom > div .card-value {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 0.25em;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.card .card-up > div:nth-child(3),
.card .card-bottom > div:nth-child(3) {
  background: transparent;
}
.card .card-bottom {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}
.card .card-bottom > div {
  padding-bottom: 0.3em;
}
.card .card-bottom > div::before {
  display: none;
}
.card .card-bottom > div:after {
  bottom: calc(var(--tag-size) * -0.5);
  left: 0;
  border: calc(var(--tag-size) * 1) solid whitesmoke;
  border-bottom-color: transparent;
  -webkit-transform-origin: bottom;
          transform-origin: bottom;
  z-index: -1;
}
.card .title {
  -webkit-transform: rotate(-35deg);
          transform: rotate(-35deg);
  font-size: 3.75em;
  opacity: 0.75;
  padding: 0;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/card.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EAEA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,8BAAA;EACA,sBAAA;EACA,sDAAA;UAAA,8CAAA;EACA,0CAAA;UAAA,kCAAA;EACA,gBAAA;EACA,8BAAA;EACA,8BAAA;UAAA,sBAAA;EAEA,oEAAA;EAAA,4DAAA;EAAA,oDAAA;EAAA,0EAAA;AADF;AAGE;EACE,WAAA;EACA,4EAAA;EAAA,oEAAA;EAAA,4DAAA;EAAA,oFAAA;EACA,0CAAA;UAAA,kCAAA;EACA,2FAAA;UAAA,mFAAA;AADJ;AAKE;EACE,gBAAA;EACA,oCAAA;EACA,8BAAA;UAAA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAHJ;AAKI;EACE,WAAA;EACA,6BAAA;UAAA,qBAAA;EACA,gCAAA;UAAA,wBAAA;EACA,8BAAA;UAAA,sBAAA;EACA,kBAAA;EACA,kCAAA;EACA,OAAA;EACA,+CAAA;EACA,4BAAA;AAHN;AAMI;EACE,aAAA;AAJN;AAQE;EACE,iBAAA;AANJ;AASE;EACE,eAAA;EACA,UAAA;AAPJ;AAUE;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EAEA,SAAA;AATJ;AAWI;EACE,mBAAA;AATN;AAYI;EACE,sBAAA;AAVN;AAaI;EACE,wBAAA;AAXN;AAcI;EACE,kBAAA;AAZN;AAeI;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,mBAAA;MAAA,WAAA;UAAA,OAAA;EACA,yBAAA;MAAA,6BAAA;EAEA,iJAAA;AAdN;AAuBQ;EACE,YAAA;EACA,kBAAA;EACA,MAAA;EACA,4BAAA;EACA,2BAAA;EACA,YAAA;AArBV;AAwBQ;EACE,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;AAtBV;AA4BE;EACE,4CAAA;UAAA,oCAAA;EACA,6FAAA;UAAA,qFAAA;AA1BJ;AA8BE;EACE,mDAAA;UAAA,2CAAA;AA5BJ;AA+BE;EACE,kEAAA;UAAA,0DAAA;AA7BJ;AAgCE;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AA9BJ;AAgCI;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,gCAAA;UAAA,wBAAA;EACA,mBAAA;EACA,cAAA;AA9BN;AAkCE;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;AAhCJ;AAkCI;EACE,iBAAA;EACA,yBAAA;AAhCN;AAmCI;EACE,mBAAA;MAAA,WAAA;UAAA,OAAA;EACA,gBAAA;AAjCN;AAmCM;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;AAjCR;AAsCE;EACE,8BAAA;EAAA,8BAAA;MAAA,+BAAA;UAAA,2BAAA;AApCJ;AAsCI;EACE,iBAAA;AApCN;AAwCE;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,mBAAA;MAAA,WAAA;UAAA,OAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,oCAAA;AAtCJ;AAwCI;EACE,mFAAA;AAtCN;AA6CI;EACE,mFAAA;AA3CN;AAkDI;EACE,UAAA;EACA,aAAA;EACA,gBAAA;AAhDN;AAkDM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AAhDR;AAoDI;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;AAlDN;AAsDE;;EAEE,WAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,8BAAA;UAAA,sBAAA;AApDJ;AAsDI;;EACE,sBAAA;EAaA;;;;;;;;;GAAA;AAtDN;AA2CM;;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,WAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;AAxCR;AA2CM;;EACE,uBAAA;AAxCR;AAwDE;EACE,iCAAA;UAAA,yBAAA;AAtDJ;AAwDI;EACE,qBAAA;AAtDN;AAwDM;EACE,aAAA;AAtDR;AAyDM;EACE,oCAAA;EACA,OAAA;EACA,kDAAA;EACA,gCAAA;EACA,gCAAA;UAAA,wBAAA;EACA,WAAA;AAvDR;AA4DE;EACE,iCAAA;UAAA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;AA1DJ","sourcesContent":[".card {\n  cursor: pointer;\n  font-size: 10px;\n  color: #282c34;\n  // 63x88\n  min-width: 15.75em;\n  max-width: 15.75em;\n  min-height: 22em;\n  max-height: 22em;\n  border-radius: 1em;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  background: whitesmoke;\n  box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 70%);\n  transform: rotate(0deg) scale(0.9);\n  overflow: hidden;\n  border: 0.5em solid whitesmoke;\n  box-sizing: border-box;\n\n  transition: top 1s, left 1s, transform 1s, margin 1s;\n\n  &:not(.hidden, .locked):hover {\n    z-index: 10;\n    transition: transform 0.5s, margin-top 0.5s, top 1s, left 1s;\n    transform: rotate(2deg) scale(1.2);\n    box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 50%),\n      0px 3px 12px 0px rgba(0, 0, 0, 30%);\n  }\n\n  & > div > div > div {\n    --tag-size: 12px;\n    min-width: calc(var(--tag-size) * 2);\n    box-sizing: border-box;\n    padding: 0.4em 0em 0;\n    font-size: 1.1em;\n    min-height: 1.2em;\n    color: #525252;\n    position: relative;\n\n    &::after {\n      content: '';\n      transform-origin: top;\n      transform: scale(1, 0.5);\n      box-sizing: border-box;\n      position: absolute;\n      bottom: calc(var(--tag-size) * -2);\n      left: 0;\n      border: calc(var(--tag-size)) solid transparent;\n      border-top-color: whitesmoke;\n    }\n\n    &::before {\n      display: none;\n    }\n  }\n\n  &.selected {\n    margin-top: -20px;\n  }\n\n  &.locked {\n    cursor: default;\n    z-index: 2;\n  }\n\n  &.hidden {\n    background: #282c34;\n    color: transparent;\n    cursor: default;\n\n    border: 0;\n\n    .card-blue {\n      background: #382491;\n    }\n\n    .card-red {\n      background: var(--red);\n    }\n\n    .card-green {\n      background: var(--green);\n    }\n\n    h2 {\n      color: transparent;\n    }\n\n    .card-content {\n      display: flex;\n      flex: 1;\n      justify-content: space-around;\n\n      background-image: linear-gradient(\n        149deg,\n        rgba(255, 255, 255, 0.29) 1px,\n        transparent 1px,\n        rgba(255, 255, 255, 0.09) 50%,\n        rgba(0, 0, 0, 0.12) 99%\n      );\n\n      .card-icon {\n        .logo {\n          height: 100%;\n          position: absolute;\n          top: 0;\n          background-repeat: no-repeat;\n          background-position: center;\n          opacity: 0.2;\n        }\n\n        .texture {\n          height: 100%;\n          position: absolute;\n          top: 0;\n          left: 0;\n          opacity: 0.3;\n        }\n      }\n    }\n  }\n\n  &.bonus {\n    transform: rotate(180deg) scale(0.9);\n    box-shadow: 0px -2px 4px 1px rgba(0, 0, 0, 50%),\n      0px -3px 12px 0px rgba(0, 0, 0, 30%);\n  }\n\n  &.stacked {\n    transform: translate(-18px, 5px) scale(0.9);\n  }\n\n  &.bonus.stacked {\n    transform: rotate(180deg) translate(18px, -5px) scale(0.9);\n  }\n\n  label {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: 2em;\n    padding: 0;\n\n    h2 {\n      font-size: 1.2em;\n      text-align: center;\n      padding: 1em 0;\n      text-transform: uppercase;\n      color: white;\n      box-sizing: border-box;\n      transform: rotate(90deg);\n      white-space: nowrap;\n      color: #4c4f55;\n    }\n  }\n\n  .card-value {\n    display: flex;\n\n    .card-value-num {\n      font-size: 1.25em;\n      color: hsla(127, 32%, 17%, 1);\n    }\n\n    .card-value-icons {\n      flex: 1;\n      text-align: left;\n\n      &.inverse path {\n        stroke: currentColor;\n        stroke-width: 0.2px;\n        fill: transparent;\n      }\n    }\n  }\n\n  .card-bottom .card-value {\n    flex-direction: row-reverse;\n\n    .card-value-icons {\n      text-align: right;\n    }\n  }\n\n  .card-content {\n    display: flex;\n    flex: 1;\n    justify-content: space-between;\n    height: 100%;\n    min-height: 100%;\n    width: 100%;\n    flex-direction: column;\n    border-radius: 0.7em;\n    overflow: hidden;\n    background-color: rgb(231, 231, 231);\n\n    &.card-attack {\n      background: linear-gradient(\n        135deg,\n        rgb(110, 223, 125) 0%,\n        rgb(110, 223, 125) 100%\n      );\n    }\n\n    &.card-defense {\n      background: linear-gradient(\n        135deg,\n        rgb(182, 182, 219) 0%,\n        rgb(182, 182, 219) 100%\n      );\n    }\n\n    .card-icon img {\n      width: 85%;\n      opacity: 0.75;\n      margin: -3.5em 0;\n\n      &.texture {\n        position: absolute;\n        top: 0;\n        left: 0;\n      }\n    }\n\n    .card-logo img {\n      width: 100%;\n      height: 100%;\n      opacity: 0.3;\n      mix-blend-mode: lighten;\n    }\n  }\n\n  .card-up,\n  .card-bottom {\n    width: 100%;\n    display: flex;\n    gap: 0.25em;\n    padding: 0 0.25em;\n    box-sizing: border-box;\n\n    & > div {\n      background: whitesmoke;\n\n      .card-value {\n        display: flex;\n        flex-direction: column;\n        gap: 0.25em;\n        align-items: center;\n      }\n\n      &:nth-child(3) {\n        background: transparent;\n      }\n\n      /*\n      &:nth-child(3) {\n        background: linear-gradient(\n          135deg,\n          rgba(199, 150, 70, 1) 0%,\n          rgba(245, 202, 138, 1) 84%,\n          rgba(255, 255, 255, 0) 84%\n        );\n      }\n      */\n    }\n  }\n\n  .card-bottom {\n    transform: rotate(180deg);\n\n    & > div {\n      padding-bottom: 0.3em;\n\n      &::before {\n        display: none;\n      }\n\n      &:after {\n        bottom: calc(var(--tag-size) * -0.5);\n        left: 0;\n        border: calc(var(--tag-size) * 1) solid whitesmoke;\n        border-bottom-color: transparent;\n        transform-origin: bottom;\n        z-index: -1;\n      }\n    }\n  }\n\n  .title {\n    transform: rotate(-35deg);\n    font-size: 3.75em;\n    opacity: 0.75;\n    padding: 0;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
